module.exports = __webpack_public_path__ + "img/repeatgrid2.3f2552fd.svg";